import React from 'react';
import { useIntl } from 'react-intl';
import { Confirm } from 'semantic-ui-react';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { slotHasData } from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

import { messages, mpfOndeAtuaSchema } from './schema';
import TemaTitulo from './TemaTitulo';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo
 * Conteúdo de cada card é um `object_browser` aninhado num `object_list`.
 *
 * Ver `Destaques/Data.tsx` para o porquê do `activeObject`/`setActiveObject`
 * no field spec e do `dataAdapter` no `onChangeField`.
 *
 * "Adicionar tema" mora no fim do último fieldset (`TemaAcoesWidget`); a
 * lixeira de remover vai no cabeçalho dos temas 2 e 3 (`TemaTitulo`) — o
 * tema 1 nunca sai. Tema vazio sai direto; com dado, pede confirmação antes
 * de apagar.
 */
const Data = (props) => {
  const {
    block,
    blocksConfig,
    data,
    onChangeBlock,
    visibleSlots,
    onAddTema,
    onRemoveTema,
  } = props;
  const intl = useIntl();
  const [confirming, setConfirming] = React.useState<number | null>(null);

  const requestRemove = (slot: number) =>
    slotHasData(data, slot) ? setConfirming(slot) : onRemoveTema(slot);

  const baseSchema = mpfOndeAtuaSchema({
    intl,
    activeObjects: props.activeObjects,
    setActiveObject: props.setActiveObject,
    visibleSlots,
    onAddTema,
  });
  const schema = {
    ...baseSchema,
    fieldsets: baseSchema.fieldsets.map((fieldset) => {
      const slot = Number(/^tema(\d+)$/.exec(fieldset.id)?.[1]);
      return slot > 1
        ? {
            ...fieldset,
            title: (
              <TemaTitulo
                title={fieldset.title}
                slot={slot}
                onRemove={requestRemove}
              />
            ),
          }
        : fieldset;
    }),
  };

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <>
      <BlockDataForm
        {...props}
        schema={schema}
        title={schema.title}
        onChangeField={(id, value) =>
          dataAdapter({ block, data, id, onChangeBlock, value })
        }
        onChangeBlock={onChangeBlock}
        formData={data}
        block={block}
      />

      <Confirm
        open={confirming !== null}
        content={intl.formatMessage(messages.removeTemaConfirm, {
          slot: confirming,
        })}
        confirmButton={intl.formatMessage(messages.removeTema, {
          slot: confirming,
        })}
        cancelButton={intl.formatMessage(messages.removeTemaCancel)}
        onCancel={() => setConfirming(null)}
        onConfirm={() => {
          onRemoveTema(confirming);
          setConfirming(null);
        }}
      />
    </>
  );
};

export default withObjectBrowser(Data);
